import { Logo } from "../lib/brand";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-secondary text-secondary-foreground py-12 border-t border-secondary-foreground/10">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl flex flex-col md:flex-row gap-6 items-start md:items-center justify-between">
        <div className="flex items-center gap-4">
          <Logo variant="dark" className="h-14 w-auto" testId="footer-logo" />
          <div className="hidden sm:block border-l border-secondary-foreground/20 pl-4">
            <div className="font-sans text-[10px] uppercase tracking-[0.25em] text-secondary-foreground/70">
              Madikeri · Coorg · Karnataka
            </div>
          </div>
        </div>
        <div className="font-sans text-xs text-secondary-foreground/60 max-w-md">
          © {new Date().getFullYear()} Aroha Homes. All rights reserved. A family-run homestay in the
          misty hills of Madikeri.
        </div>
      </div>
    </footer>
  );
}
